import axios from 'axios';
import authHeader from './auth-header';

const API_URL = 'https://sporteventmanagement.it/api/unit/';

class UnitService {

	add(unit) {
	    return axios.post(API_URL + 'add', unit, { headers: authHeader() });
	}

	getAll(){
		return axios.get(API_URL + 'all', { headers: authHeader() });
	}

	delete(unit) {
	    return axios.post(API_URL + 'delete', unit, { headers: authHeader() });
	}

}

export default new UnitService();
